import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';

import ProcessField from 'components/core/fields/ProcessField';
import InfoMessages from 'components/core/help/InfoMessages';
import ProcessUtils from 'utils/ProcessUtils';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIEInput from 'components/core/editable/RIEInput';
import ProcessService from 'services/ProcessService';

/**
 * Base class for process form field components that can be reused throughout the PCM.
 */
export default class ProcessNameField extends ProcessField {

    static propTypes = Object.assign({
        openTabOnRename: PropTypes.bool,
        wizardMode: PropTypes.bool,
        onProcessRenamed: PropTypes.func
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
        openTabOnRename: true

    }, ProcessField.defaultProps);

    onNameUpdated = (fieldPath, value) => {
        const editor = ProcessUtils.getEditor(this.props.process);
        editor.renameProcess(value, this.props.openTabOnRename, this.props.wizardMode);
        editor.commit();

        if (this.props.onProcessRenamed) {
            this.props.onProcessRenamed(value);
        }
    };

    render() {
        const processList = ProcessService.getMyState().sortedIds;
        const checkUnique = {
            label: 'process',
            list: processList
        };
        return (
            <Flexbox className={this.props.className} flexDirection="row" alignItems="flex-start">
                <InfoBoxLabel
                    label="Process Name"
                    message={InfoMessages.processName}
                />
                <RIEInput
                    value={this.props.process.name}
                    change={this.onNameUpdated}
                    fieldPath={['name']}
                    isDisabled={!this.props.hasWritePermissions}
                    urlCommit
                    processId={this.props.process.name}
                    processErrors={this.props.processErrors}
                    formDisplay={this.props.forceFormDisplay}
                    checkUnique={checkUnique}
                />
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessNameField.js